import { render, staticRenderFns } from "./Enquetes.vue?vue&type=template&id=5ec5b8a4&scoped=true"
import script from "./Enquetes.vue?vue&type=script&lang=js"
export * from "./Enquetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec5b8a4",
  null
  
)

export default component.exports